'use strict';

exports.__esModule = true;
exports.SearchButton = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Returns a button like the male/female/days selected in the search bar..
* @param {SearchButtonType} props the component props.
* @returns {Function} the functional component
**/
//flow
var SearchButton = exports.SearchButton = function SearchButton(props) {
	return _react2.default.createElement(
		'button',
		{
			className: _style2.default.filterButton + ' ' + (props.isSelected ? _style2.default.selected : null) + ' btn solid',
			onClick: props.onClick
		},
		props.iconClass ? _react2.default.createElement('i', { className: props.iconClass }) : null,
		props.name
	);
};

SearchButton.propTypes = {
	iconClass: require('react').PropTypes.any,
	name: require('react').PropTypes.any,
	isSelected: require('react').PropTypes.any,
	onClick: require('react').PropTypes.func
};
SearchButton.displayName = 'SearchButton';

SearchButton.defaultProps = {
	onClick: function onClick() {}
};


// WEBPACK FOOTER //
// ./components/advanced-search-bar/lib/components/search-button.js